import Chart from 'chart.js';
import classNames from 'classnames';
import map from 'lodash/map';
import sum from 'lodash/sum';
import moment from 'moment';
import numeral from 'numeral';
import React from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {fetchStatsActiveUsers} from '../../../../../actions/entities/statistics/activeUsers';
import earthFlag from '../../../../../assets/img/other/flag-earth.svg';
import DateRangePickerWrapper from '../../../../../components/DatePicker/DateRangePickerWrapper';
import Loader from '../../../../../components/Loader';
import {getIncrease} from '../../../../../helpers/stats';
import './index.css';

let chart;

class ActiveUsersWidget extends React.Component {
  constructor(props) {
    super(props);

    // We set the date to yesterday and we subtract 30 days
    const today = new Date();
    const end = moment(today.setDate(today.getDate())).format('YYYY-MM-DD');
    const start = moment(today.setDate(today.getDate() - 30)).format(
      'YYYY-MM-DD',
    );
    const startRegister = null;
    const endRegister = null;

    this.state = {end, endRegister, start, startRegister, lang: 'ALL'};
  }

  fetchStats() {
    const {end, endRegister, start, startRegister} = this.state;
    const {isFetching} = this.props;

    if (!isFetching) {
      const payload = {
        endDate: moment(end).format('YYYY-MM-DD'),
        startDate: moment(start).format('YYYY-MM-DD'),
      };
      if (startRegister)
        payload.startCreatedDate = moment(startRegister).format('YYYY-MM-DD');
      if (endRegister)
        payload.endCreatedDate = moment(endRegister).format('YYYY-MM-DD');

      this.props.dispatch(
        fetchStatsActiveUsers(payload, null, (type, error) =>
          swal({
            title: `Oops...`,
            type: 'error',
            html:
              `Something went wrong:<br/>"${type}"<br/>${error}<br/>` +
              `<pre><code>${JSON.stringify(error, undefined, 4)}</code></pre>`,
          }),
        ),
      );
    }
  }

  toggleLang(value) {
    const {lang} = this.state;

    if (lang === value) {
      this.setState({lang: 'ALL'});
    } else {
      this.setState({lang: value});
    }
  }

  componentDidMount() {
    const ctx = document.getElementById('active-users-chart');
    if (ctx)
      chart = new Chart(ctx, {
        type: 'bar',
        data: {datasets: []},
        options: {
          scales: {
            xAxes: [
              {
                id: 'date',
                type: 'time',
                stacked: true,
              },
            ],
            yAxes: [
              {
                id: 'members',
                type: 'linear',
                stacked: true,
              },
            ],
          },
        },
      });
  }

  updateGraph(data) {
    const {activeUsers} = data;
    const {lang} = this.state;

    const datasets = [
      {
        label: 'MPG',
        backgroundColor: '#ed9728',
        xAxisID: 'date',
        yAxisID: 'members',
        data: [],
      },
      {
        label: 'MPP',
        backgroundColor: '#9fc99e',
        xAxisID: 'date',
        yAxisID: 'members',
        data: [],
      },
      {
        label: 'Predict',
        backgroundColor: '#819bb7',
        xAxisID: 'date',
        yAxisID: 'members',
        data: [],
      },
      {
        label: 'Quiniela',
        backgroundColor: '#dd9189',
        xAxisID: 'date',
        yAxisID: 'members',
        data: [],
      },
      {
        label: 'MPT',
        backgroundColor: '#aae750',
        xAxisID: 'date',
        yAxisID: 'members',
        data: [],
      },
    ];

    map(activeUsers, stat => {
      datasets[0].data.push({
        x: moment(stat.date).format('LL'),
        y: (stat.mpg && parseInt(stat.mpg[lang], 10)) || 0,
      });
      datasets[1].data.push({
        x: moment(stat.date).format('LL'),
        y: (stat.mpp && parseInt(stat.mpp[lang], 10)) || 0,
      });
      datasets[2].data.push({
        x: moment(stat.date).format('LL'),
        y: (stat.mppEn && parseInt(stat.mppEn[lang], 10)) || 0,
      });
      datasets[3].data.push({
        x: moment(stat.date).format('LL'),
        y: (stat.mppEs && parseInt(stat.mppEs[lang], 10)) || 0,
      });
      datasets[4].data.push({
        x: moment(stat.date).format('LL'),
        y: (stat.mpt && parseInt(stat.mpt[lang], 10)) || 0,
      });
    });

    chart.data.datasets = datasets;
    chart.update();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data !== this.props.data) {
      this.updateGraph(nextProps.data);
    }
  }

  componentDidUpdate() {
    this.props.data && this.updateGraph(this.props.data);
  }

  renderTable() {
    const {data} = this.props;
    const {lang} = this.state;

    if (!data) return false;

    const {current, previous} = data.countries[lang];
    const totalCurrent = sum(Object.values(current));
    const totalPrevious = sum(Object.values(previous));

    return (
      <div className="table-responsive table-fixed-height table-full-width">
        <table className="table table-bordered no-margin">
          <thead>
            <tr className="bg-gray">
              <th className="text-center">From</th>
              <th className="text-center">Nombre</th>
              <th className="text-center">%</th>
              <th className="text-center">S-1</th>
              <th className="text-center">% S-1</th>
            </tr>
          </thead>
          <tbody>
            {map(current, (value, index) => {
              return (
                <tr key={index}>
                  <th className="text-center">{index}</th>
                  <th className="text-center">
                    {numeral(value).format('0,0')}
                  </th>
                  <th className="text-center">
                    {numeral((value / totalCurrent) * 100).format('0,0')} %
                  </th>
                  <th className="text-center">
                    {numeral(previous[index]).format('0,0')}
                  </th>
                  <td
                    className={classNames('text-center', {
                      'text-green': value > previous[index],
                      'text-red': previous[index] > value,
                    })}>
                    {(!previous[index] || previous[index] === 0) &&
                    value !== 0 ? (
                      <span>
                        +<span style={{fontSize: '18px'}}>∞</span>
                      </span>
                    ) : (
                      numeral(getIncrease(value, previous[index]) || 0).format(
                        '+0',
                      )
                    )}{' '}
                    %
                  </td>
                </tr>
              );
            })}
            <tr>
              <th className="text-center">TOTAL</th>
              <th className="text-center">
                {numeral(totalCurrent).format('0,0')}
              </th>
              <th className="text-center">100%</th>
              <th className="text-center">
                {numeral(totalPrevious).format('0,0')}
              </th>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const {end, endRegister, start, startRegister, lang} = this.state;
    const {isFetching} = this.props;

    return (
      <div id="active-users-widget">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              <i className="fa fa-user-circle-o" /> Utilisateurs actifs (entre
              le {this.state.start} et le {this.state.end})
            </h3>
            <br />
            {`Nombre de users étant dans au moins une ligue active (status >= 4) + s'étant connecté entre le ${this.state.start} et le ${this.state.end}`}
          </div>
          <div className="box-body">
            <div className="margin-bottom text-center">
              <div className="inline lang">
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'FR',
                  })}
                  onClick={() => this.toggleLang('FR')}>
                  <span className="flag-icon flag-icon-fr" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'GB',
                  })}
                  onClick={() => this.toggleLang('GB')}>
                  <span className="flag-icon flag-icon-gb" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'ES',
                  })}
                  onClick={() => this.toggleLang('ES')}>
                  <span className="flag-icon flag-icon-es" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'OTHER',
                  })}
                  onClick={() => this.toggleLang('OTHER')}>
                  <img
                    src={earthFlag}
                    alt="Drapeau de la terre"
                    className="flag-img-btn"
                  />
                </button>
              </div>
              <div className="inline data-range-picker">
                <DateRangePickerWrapper
                  initialStartDate={moment(start)}
                  initialEndDate={moment(end)}
                  minimumNights={0}
                  onDatesChange={({startDate, endDate}) => {
                    this.setState({
                      start: moment(startDate).format('YYYY-MM-DD'),
                      end: moment(endDate).format('YYYY-MM-DD'),
                    });
                  }}
                />
                <button
                  className="btn btn-default"
                  onClick={() => this.fetchStats()}>
                  <i className="fa fa-refresh" />
                </button>
              </div>
              <p className="mt-3">
                Période d'inscription :
                <div className="inline data-range-picker fullBorderedInput">
                  <DateRangePickerWrapper
                    initialStartDate={startRegister && moment(startRegister)}
                    initialEndDate={endRegister && moment(endRegister)}
                    minimumNights={0}
                    onDatesChange={({startDate, endDate}) => {
                      this.setState({
                        startRegister: moment(startDate).format('YYYY-MM-DD'),
                        endRegister: moment(endDate).format('YYYY-MM-DD'),
                      });
                    }}
                  />
                </div>
              </p>
            </div>
            <div className="row">
              <div className="col-xs-12">
                <div
                  className={classNames(
                    'chart',
                    this.props.data ? 'displayGraphs' : 'notDisplayGraphs',
                  )}>
                  <canvas id="active-users-chart" />
                </div>
              </div>
              <div className="col-xs-12">{this.renderTable()}</div>
            </div>
          </div>
          {isFetching && <Loader />}
        </div>
      </div>
    );
  }
}

export default connect(
  state => state.app.statistics.activeUsers,
  dispatch => ({dispatch}),
)(ActiveUsersWidget);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Widgets/ActiveUsers/index.js